<template>
  <v-dialog v-model="reportPopup.visible" max-width="800px">
    <report-form
      :content-id="reportPopup.contentId"
      :type="reportPopup.contentType"
      v-on:report="closeReportPopup"
      v-on:close="closeReportPopup"
      @error="showSnackbar({ error: true, text: 'An unexpected error occurred' })"
    ></report-form>
  </v-dialog>
</template>

<script>
import ReportForm from "@/components/report-form.vue";
import { mapMutations } from "vuex";

export default {
  name: "report-popup.vue",
  components: { ReportForm },

  computed: {
    reportPopup() {
      return this.$store.state.reportPopup;
    },
  },

  methods: {
    ...mapMutations(["closeReportPopup", "showSnackbar"]),
  },
};
</script>

<style scoped></style>
